var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleCollapse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 39 39"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#circle-collapse_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.167 5C11.342 5 5 11.343 5 19.167s6.342 14.166 14.167 14.166c7.824 0 14.166-6.342 14.166-14.166C33.333 11.343 26.991 5 19.167 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m21.333 24.333-5-5 5-5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3956CC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21.333 24.333-5-5 5-5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "circle-collapse_svg__a",
  width: 38.333,
  height: 38.333,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_230_1161"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_230_1161",
  result: "shape"
})))));
export { SvgCircleCollapse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8yMzBfMTE2MSkiPgo8cGF0aCBkPSJNMTkuMTY2NiA1LjAwMDA0QzExLjM0MjUgNS4wMDAwNCA0Ljk5OTkxIDExLjM0MjcgNC45OTk5MSAxOS4xNjY3QzQuOTk5OTIgMjYuOTkwNyAxMS4zNDI1IDMzLjMzMzQgMTkuMTY2NiAzMy4zMzM0QzI2Ljk5MDYgMzMuMzMzNCAzMy4zMzMzIDI2Ljk5MDcgMzMuMzMzMyAxOS4xNjY3QzMzLjMzMzMgMTEuMzQyNyAyNi45OTA2IDUuMDAwMDQgMTkuMTY2NiA1LjAwMDA0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIxLjMzMzMgMjQuMzMzNEwxNi4zMzMzIDE5LjMzMzRMMjEuMzMzMyAxNC4zMzM0IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjEuMzMzMyAyNC4zMzM0TDE2LjMzMzMgMTkuMzMzNEwyMS4zMzMzIDE0LjMzMzQiIHN0cm9rZT0iIzM5NTZDQyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kXzIzMF8xMTYxIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzguMzMzMyIgaGVpZ2h0PSIzOC4zMzM0IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyLjUiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjI1IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfMjMwXzExNjEiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMjMwXzExNjEiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";